'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'
import { ThemeProvider } from '@/components/theme-provider'

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        // 5 min stale time — most app data doesn't change faster than this,
        // and this prevents the "component re-mounts, instantly refetches,
        // UI flickers" pattern every time the user navigates between tabs.
        staleTime: 5 * 60 * 1000,
        // Always render the previous result while a background refetch is
        // in flight. Without this, ANY poll briefly flips isLoading/isFetching
        // and components using those flags flash a spinner/skeleton.
        placeholderData: (prev: unknown) => prev,
        // Disable every automatic refetch trigger except the explicit
        // refetchInterval a component opts into.
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        // One retry on failure — stops the "retry every 1s on 500s" burst
        // that also caused visible flicker under a failing endpoint.
        retry: 1,
      },
    },
  }))

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </ThemeProvider>
  )
}
